import { AnchorButton } from "@svea/design-system-components-react";
import { Heading, P, useText } from "@sveabank/cc-common";
import { Link } from "react-router";
import Content from "../../components/content";
import PageNavigationFooter from "../../components/page-navigation-footer";
import { withLoader } from "../../hoc/with-loader";
import { usePageContext } from "../../hooks/context";
import { usePages } from "../../hooks/usePages";
import { useFullAccessUsers } from "./hooks";
import UserCard from "./user-card";

const FullAccessUsersPage = () => {
	const { assignedFullAccesUsers, unassignedRepresentatives, currentUserNationalId } =
		usePageContext(useFullAccessUsers);

	const { nextPage, prevPage } = usePages();
	const [t, texts] = useText();

	return (
		<Content my={8}>
			<Heading.H3>{t(texts.fullAccessUsersPage.assignedUsers.heading)}</Heading.H3>
			<P>{t(texts.fullAccessUsersPage.assignedUsers.subHeading)}</P>
			<div className="tablet:flex-row my-8 flex flex-col flex-wrap gap-4 pb-4">
				{assignedFullAccesUsers.map((assignedUser) => (
					<UserCard
						key={assignedUser.nationalId}
						firstName={assignedUser.firstName}
						lastName={assignedUser.lastName}
						nationalId={assignedUser.nationalId}
						editable={assignedUser.nationalId !== currentUserNationalId}
						isAdded
					/>
				))}
			</div>

			{unassignedRepresentatives.length > 0 && (
				<>
					<Heading.H3>{t(texts.fullAccessUsersPage.unAssignedUsers.heading)}</Heading.H3>
					<P>{t(texts.fullAccessUsersPage.unAssignedUsers.subHeading)}</P>
					<div className="tablet:flex-row mt-8 flex flex-col flex-wrap gap-4 pb-4">
						{unassignedRepresentatives.map((unAssignedUser) => (
							<UserCard
								key={unAssignedUser.nationalId}
								firstName={unAssignedUser.names.firstNames}
								lastName={unAssignedUser.names.lastNames}
								nationalId={unAssignedUser.nationalId}
							/>
						))}
					</div>
				</>
			)}
			<PageNavigationFooter>
				{nextPage && (
					<AnchorButton as={Link} to={nextPage}>
						{t(texts.common.continue)}
					</AnchorButton>
				)}
				{prevPage && (
					<AnchorButton as={Link} variant="secondary" to={prevPage}>
						{t(texts.common.goBack)}
					</AnchorButton>
				)}
			</PageNavigationFooter>
		</Content>
	);
};

export default withLoader(useFullAccessUsers, FullAccessUsersPage);
